import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { APP_URL, USERSROLE } from 'types';
import { SideNavLink } from 'carbon-components-react/lib/components/UIShell';
import {
  Add16,
  Events16,
  Email16,
  Home16,
  EmailNew16
} from '@carbon/icons-react';
import { ReactComponent as AddNew16 } from 'assets/icons/add-new-draft.svg';
import { useHistory } from 'react-router-dom';

import { selectMailboxUnmatchedCount } from 'redux/session/selectors';

export const LeftNavCommonMenuItem: React.FC<Props> = ({
  disableNav,
  isSmallScreen,
  hasDraft,
  userRole
}) => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  const mailboxUnmatchedCount = useSelector(selectMailboxUnmatchedCount);

  const queryParams = new URLSearchParams(history?.location?.search);
  const preview = queryParams.get('preview');
  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);
  return (
    <>
      <SideNavLink
        aria-disabled={disableNav}
        aria-current={pathname === APP_URL.ROOT_URL ? 'page' : undefined}
        renderIcon={Home16}
        onClick={
          disableNav ? undefined : () => history.push(`${APP_URL.ROOT_URL}`)
        }
      >
        Home
      </SideNavLink>
      <SideNavLink
        aria-disabled={disableNav}
        aria-current={pathname === APP_URL.NEW_ENQUIRY ? 'page' : undefined}
        renderIcon={hasDraft ? AddNew16 : Add16}
        className="add-icon"
        onClick={
          disableNav ? undefined : () => history.push(`${APP_URL.NEW_ENQUIRY}`)
        }
      >
        New enquiry
      </SideNavLink>
      <SideNavLink
        aria-disabled={disableNav}
        aria-current={pathname === APP_URL.MAIL_BOXES ? 'page' : undefined}
        renderIcon={
          mailboxUnmatchedCount && mailboxUnmatchedCount > 0
            ? EmailNew16
            : Email16
        }
        onClick={
          disableNav ? undefined : () => history.push(`${APP_URL.MAIL_BOXES}`)
        }
        className="mailbox-icon"
      >
        {`Mailbox ${
          mailboxUnmatchedCount &&
          mailboxUnmatchedCount > 0 &&
          pathname !== APP_URL.MAIL_BOXES
            ? '(' + mailboxUnmatchedCount + ')'
            : ''
        }`}
      </SideNavLink>
      {(!isSmallScreen || userRole === USERSROLE.TRIALUSER) && (
        <SideNavLink
          aria-disabled={disableNav}
          aria-current={
            pathname === APP_URL.TEAMS || `/${preview}` === APP_URL.TEAMS
              ? 'page'
              : undefined
          }
          renderIcon={Events16}
          onClick={
            disableNav ? undefined : () => history.push(`${APP_URL.TEAMS}`)
          }
        >
          Teams
        </SideNavLink>
      )}
    </>
  );
};

type Props = {
  isSmallScreen: boolean;
  disableNav?: boolean;
  userRole?: string;
  hasDraft?: boolean;
};

export default LeftNavCommonMenuItem;
